import { ChangeEvent } from 'react';
import { Box, Icon, Text } from '@nimbus-ds/components';
import { CheckCircleIcon, MoneyIcon } from '@nimbus-ds/icons';
import { InputNumberNimbus } from 'commons/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface InputWithErrorProps {
  hasError: boolean;
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  discount: string;
  discountNumber: number | undefined;
  maxDiscount: number;
}

function InputWithError({
  hasError,
  handleInputChange,
  discount,
  discountNumber,
  maxDiscount,
}: Readonly<InputWithErrorProps>) {
  const t = useTranslationOrders();

  return (
    <Box>
      <InputNumberNimbus
        appearance={hasError ? 'danger' : 'neutral'}
        type="float2d"
        onChange={handleInputChange}
        append={<Icon source={<MoneyIcon color="grey" />} />}
        defaultDecimals={2}
        value={discount}
      />
      {hasError && (
        <Box display="flex" gap="0-5" paddingTop="1">
          <Icon
            color="danger-textLow"
            source={<CheckCircleIcon size="small" />}
          />
          <Text
            as="span"
            color="danger-textLow"
            fontSize="caption"
            lineHeight="caption"
          >
            {discountNumber && discountNumber > maxDiscount
              ? t('editOrders.discountModal.errorMaxCaption')
              : t('editOrders.discountModal.errorCaption')}
          </Text>
        </Box>
      )}
    </Box>
  );
}

export default InputWithError;
